import {useCallback} from 'react';
import {useLazyQuery} from '@apollo/client';

import {GetPlansPreview} from 'web-app/react/plans/manage-plan/queries';
import type {
    PreviewPlansQuery,
    PreviewPlansQueryVariables,
} from 'web-app/react/plans/manage-plan/__generated__/queries.api-types';

import type {Plan} from '../helpers/plan-types';
import {transformPlanToPlanInput} from '../helpers/transform-plan-to-plan-input';

export const useValidatePlans = () => {
    const [getPlansPreview] = useLazyQuery<PreviewPlansQuery, PreviewPlansQueryVariables>(GetPlansPreview);

    const validatePlans = useCallback(
        async (plans: Array<Plan>, siteId: string) => {
            const result = await getPlansPreview({
                variables: {
                    planInputs: plans.map(transformPlanToPlanInput),
                    siteId,
                },
            });

            return result;
        },
        [getPlansPreview],
    );

    return {validatePlans};
};
